export default "__VITE_ASSET__d33f785c__"